import axios from 'axios'
import { Link } from 'react-router'
import React from 'react'
import ListReferred from './ListReferred'
import Refer from './Refer'
import Spinner from './Spinner'

class ReferOverview extends React.Component { // react-disa
  constructor(props) {
    super(props)
    this.updateHandler = this.updateHandler.bind(this)
    this.state = {
      code: '',
      referred: null,
    }
  }
  componentDidMount() {
    if (typeof window !== 'undefined' && window.location.search) {
      const that = this
      that.setState({ referred: 'loading' })
      let str = ''
      let code = ''
      str = window.location.search
      code = str.split('=').pop()
      // that = this???? Yes, **this.state** don't work by **it**self inside axios
      axios.post('/api/signin/register').then((result) => {
        axios.get('/api/profile', {
          params: {
            code,
          },
        }).then((response) => {
          if (response.data.referred) {
            that.setState({ referred: response.data.referred, code })
          } else if (result.data.success === true) {
            axios.get('/api/profile', {
              params: {
                code,
              },
            }).then((res) => {
              that.setState({ referred: res.data.referred, code })
            }).catch((error) => {
              console.log(error) // eslint-disable-line no-console
            })
          } else {
            that.setState({ referred: null })
          }
        })
      }).catch((error) => {
        console.log(error) // eslint-disable-line no-console
      })
    }
  }
  theList() {
    if (this.state.referredForm === true) {
      return <Spinner />
    }
    return <ListReferred referred={this.state.referred.data} />
  }
  updateHandler() {
    this.componentDidMount()
  }
  render() {
    return (<div>
      {
        this.state && this.state.referred == null
          ? <div className="col-12 col-md-8 mb-7">
            <h3 className="mb-4">Oops</h3>
            <span
              style={{
                fontSize: '1.1rem',
              }}
            >
                Olá, não foi possível verificar seu código de indicação, caso você seja <strong>cliente do Gravíttem</strong> e não esteja conseguindo acessar a página de indicação, por favor envie um e-mail com o seu código para <strong>comercial@softin.com.br</strong> a fim de solucionar esse inconveniente.
            </span>
            <div className="mt-3">
              <Link
                style={{
                  fontSize: '1.1rem',
                }}
                to="/"
              >Voltar para a página inicial
                <i
                  className="material-icons ml-1 small"
                  aria-hidden="true"
                  style={{
                    width: '0px',
                    whiteSpace: 'normal',
                  }}
                >arrow forward
                </i>
              </Link>
            </div>
          </div> //eslint-disable-line
          : this.state.referred === 'loading'
            ? <Spinner />
            :
            <div className="row">
              <div className="col-12 col-md-5 mb-5">
                <Refer code={this.state.code} onChange={this.updateHandler} />
              </div>
              <div className="col-12 col-md-7">
                {this.theList()}
              </div>
            </div>
      }
    </div>)// eslint-disable-line
  }
}

export default ReferOverview



// WEBPACK FOOTER //
// ./client/components/ReferOverview.js